// @ts-check
import { createCrudProp } from '../utils/crud-prop'
import { sortByTimeIfExists } from '../utils/sort-by'

const sigProp = createCrudProp({
  rootKey: 'sig',
  requiredProps: ['name', 'signature', 'time'],
  sortFn: sortByTimeIfExists,
})

/**
 * @param {{ name: string; signature: string; time: number }} param0 The signature name
 * @returns {any} The changes to apply to the case.
 */
export const actionAddSignature = ({ name, signature, time }) =>
  sigProp.actionAdd({ name, signature, time })

/**
 * @param {string} id The signature ID
 * @returns {any} The changes to apply to the case.
 */
export const actionRemoveSignature = sigProp.actionRemove

/** @type {CaseSelector<CaseSignatureEntry[]>} */
export const selectSignatures = sigProp.select
